<template>
  <!-- 找回密码页 -->
  <div class="find-pwd cognition__content-main">
    <div class="find-pwd__title cognition__content-title">找回密码</div>
      <el-form :model="findForm" :rules="rules" ref="findF">
        <el-form-item label="找回方式" prop="type">
          <el-radio-group v-model="findForm.type" @change="radioChange">
            <el-radio label="1">用户名</el-radio>
            <el-radio label="2">邮箱</el-radio>
            <el-radio label="3">短信找回</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="用户名" prop="username" v-if="findForm.type === '1'">
          <el-input v-model="findForm.username" placeholder="请输入用户名" :maxlength="50" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email" v-if="findForm.type === '2'">
          <el-input v-model="findForm.email" placeholder="请输入邮箱" :maxlength="50" />
        </el-form-item>
        <template v-if="findForm.type === '3'">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="findForm.mobile" placeholder="请输入手机号" :maxlength="50" />
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="findForm.code" placeholder="请输入验证码" :maxlength="50">
              <el-button slot="append" @click="sendMobile" :disabled="!!countDown">{{codeTitle}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="findForm.password" placeholder="请输入新密码" show-password :maxlength="50" />
          </el-form-item>
          <el-form-item label="确认新密码" prop="doublePwd">
            <el-input v-model="findForm.doublePwd" placeholder="请再次输入新密码" show-password :maxlength="50" />
          </el-form-item>
        </template>
        <el-form-item>
          <el-alert :title="tip" type="info" show-icon :closable="false" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">找回密码</el-button>
          <router-link to="/login">
            <el-button>返回登录</el-button>
          </router-link>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import { encryptByDES } from "@/util";
import { validatorMobile } from '@/util/validate.js'
import { resetSendCodeApi, resetByMobileApi, getSecretKeyApi } from '@/util/api'
const TIPS = ['', '通过用户名绑定的邮箱找回', '通过邮箱找回关联账户', '通过手机号找回关联账户']
export default {
  data() {
    return {
      uid: '',
      findForm: {
        type: "1",
        username: "",
        email: '',
        mobile: '',
        code: '',
        password: '',
        doublePwd: ''
      },
      rules: {
        type: [{ required: true, message: "请选择找回方式", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatorMobile, trigger: "blur" }
        ],
        code: [
          { required: true, min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        doublePwd: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.validatePwd, trigger: "blur" }
        ]
        
      },
      countDown: 0,
      timer: null
    };
  },
  computed: {
    tip() {
      return TIPS[parseInt(this.findForm.type)]
    },
    codeTitle() {
      return this.countDown ? `${this.countDown}秒后重新获取` : '发送验证码'
    }
  },
  methods: {
    // 重复密码校验
    validatePwd(rule, value, callback) {
      if(value !== this.findForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },
    submit() {
      this.$refs["findF"].validate(valid => {
        if (valid) {
          switch(this.findForm.type) {
            case '1':
            case '2':
              this.sendEmail();
              break;
            case '3':
              this.resetPwd()
              break;
          }
        }
      });
    },
    // 重置密码
    resetPwd() {
      let { code, mobile, password } = this.findForm
      code = code.trim()
      mobile = mobile.trim()
      password = password.trim()
      getSecretKeyApi(mobile).then(res => {
        if(res.code === 0) {
          password = encryptByDES(password, res.data)
          return resetByMobileApi({
            code, mobile, password
          })
        }
        return res
      }).then(res => {
        if(res.code === 0) {
          this.$alert(res.msg, "通知", {
            confirmButtonText: "修改成功",
            center: true,
            callback: () => {
              this.$router.push("/login")
            }
          });
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 发送邮件or手机验证码
    sendCode(type) {
      const params = { noToken: true, type }
      let getMsg
      switch(params.type) {
        case 1:
          params.username = this.findForm.username
          getMsg = (email) => `我们给您用户名绑定的邮箱（${email}）发送了一封邮件，请查收并重置密码。`
          break;
        case 2:
          params.username = this.findForm.email
          getMsg = (email) => `我们给您的注册邮箱（${email}）发送了一封邮件，请查收，并重置密码。`
          break;
        case 3:
          params.username = this.findForm.mobile
          break;
      }
      return resetSendCodeApi(params).then(res => {
        if(res.code === 0) res.msg = getMsg ? getMsg(res.data) : `验证码已发送`
        return res
      })
    },
    // 发送验证码
    sendMobile() {
      this.$refs['findF'].validateField('mobile', err => {
        if(!err) {
          this.sendCode(3).then(res => {
            if(res.code === 0) {
              clearInterval(this.timer)
              this.countDown = 60
              this.timer = setInterval(() => {
                this.countDown--
                if(!this.countDown) clearInterval(this.timer)
              }, 1000)
              this.$message({ type: 'success', message: res.msg })
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    // 发送邮件
    sendEmail() {
      this.sendCode(parseInt(this.findForm.type)).then(res => {
        if (res.code === 0) {
          this.$alert(res.msg, "通知", {
            confirmButtonText: "我知道了",
            center: true,
            callback: () => {
              this.$router.push("/login")
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    radioChange(radio) {
      // 移除表单项的校验结果
      this.$refs["findF"].resetFields();
      this.findForm.type = radio
    }
  }
};
</script>

<style scoped lang="less">
</style>
